module.exports = __webpack_public_path__ + "static/img/driver2.7abfb949.png";